import React from "react";

export const VideoPlayer = (props: {
  src: string;
  className?: string;
  title?: string;
}) => {
  const getVideoEmbedUrl = (url: string) => {
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const videoId = url.split("v=")[1] || url.split("/").pop();
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (url.includes("vimeo.com")) {
      const videoId = url.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}`;
    } else {
      return null; // Plain video URL will be handled in the `video` tag
    }
  };

  const embedUrl = getVideoEmbedUrl(props.src);

  return (
    <>
      {embedUrl ? (
        <iframe
          src={embedUrl}
          className={props.className}
          title={props.title || "Video Player"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <video
          src={props.src}
          className={props.className}
          title={props.title || "Video Player"}
          controls
        ></video>
      )}
    </>
  );
};
